import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {user} from '../../../store/reducers/user';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import AgyleDialog from '../../../components/modal/agyleDialog';
import {useTranslation} from 'react-i18next';
import Formatter from '../../../util/formatter';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Notes from '../../../util/notes';
import _ from 'lodash';
import config from '../../../app/config';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import MiniFormDialog from '../../../components/modal/miniFormDialog';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background + ` !important`,
    },
    groupRoot: {
        marginBottom: 10,
        padding: 5,
        borderRadius: 5,
    },
    paper: {
        padding: 10,
        backgroundColor: '#252525',
    },
    centerRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    userLog: {
        fontSize: 11,
        fontStyle: 'italic',
        color: theme.palette.mode === 'light' ? '#4B4B4B' : '#818181',
    },
    comment: {
        fontSize: 15,
        padding: 5,
        backgroundColor: theme.palette.background.default,
        borderRadius: 5,
    },
    clinician: {
        marginBottom: 10,
    },
    row: {
        width: '100%',
        marginBottom: 10,
    },
    divider: {
        margin: '10px 0',
    },
    label: {
        color: theme.palette.inPatient.questionText,
        fontSize: 12,
        fontWeight: 600,
        marginLeft: 10,
        marginBottom: 5,
    },
    textFieldClass: {
        background: 'red',
    },
}));

const INTENDENT_MANAGEMENT_FORM_INIT = {
    edd: null,
    cdd: null,
    who: '',
    date: '',
};

function IntendentManagementForm(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);
    const [form, setForm] = useState(INTENDENT_MANAGEMENT_FORM_INIT);

    useEffect(() => {
        setForm((formLast) => {
            return {
                ...formLast,
                who: userFullName,
                date: moment().toISOString(),
            };
        });
    }, [userObject]);

    useEffect(() => {
        if (props.formData) {
            let formClone = _.cloneDeep(props.formData);
            setForm({
                ...formClone,
                who: userFullName,
                date: moment().toISOString(),
            });
        }
    }, [props.formData]);

    useEffect(() => {
        if (props.changeFormData) {
            props.changeFormData(form);
        }
    }, [form]);

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
                <div className={classes.label}>
                    {t('Estimated Discharge Date')}
                </div>

                <AgyleDatePicker
                    type="date"
                    value={form.edd}
                    noBorder={false}
                    disableFuture={false}
                    onChange={(tDate) => {
                        if (tDate) setForm({...form, edd: tDate.valueOf()});
                    }}
                    withNewBackground
                    size="large"
                />
            </Grid>

            <Grid item xs={12}>
                <div className={classes.label}>
                    {t('Confirmed Discharge Date')}
                </div>

                <AgyleDatePicker
                    type="date"
                    noBorder={false}
                    value={form.cdd}
                    disableFuture={false}
                    onChange={(tDate) => {
                        if (tDate) setForm({...form, cdd: tDate.valueOf()});
                    }}
                    withNewBackground
                    size="large"
                />
            </Grid>
        </Grid>
    );
}

function IntendentManagementFormModal(props) {
    const {t} = useTranslation();

    const [formData, setFormData] = useState(null);

    const handleSubmit = () => {
        if (props.onChange) {
            props.onChange([{
                    name: 'intendentManagement',
                    value: formData,
                    noteToAdd: Notes.getIntendentManagementNote(formData),
                }],
            );
        }

        if (props.onClose) props.onClose();
    };

    const removeOxygen = () => {
        if (props.onChange) {
            props.onChange([{
                    name: 'intendentManagement',
                    value: null,
                    noteToAdd: Notes.getIntendentManagementNote(null),
                }],
            );
        }

        if (props.onClose) props.onClose();
    };

    return (
        <MiniFormDialog
            open={props.open}
            onClose={props.onClose}
            title={t(props._formTitle)}
            disableSubmit={props.disableSave}
            onSave={handleSubmit}
            buttons={[
                <AgyleButton
                    disabled={props.disableSave}
                    onClick={removeOxygen}
                >
                    {'Delete'}
                </AgyleButton>,
            ]}
            formOptions={props._formOptions}
        >
            <IntendentManagementForm
                formData={props.patient?.intendentManagement}
                changeFormData={setFormData}
            />
        </MiniFormDialog>
    );
}

export default IntendentManagementFormModal;